import { render, staticRenderFns } from "./NxFormCaptcha.vue?vue&type=template&id=6c34b604&scoped=true&"
import script from "./NxFormCaptcha.vue?vue&type=script&lang=js&"
export * from "./NxFormCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34b604",
  null
  
)

export default component.exports